export enum DB_STATE {
  NONE = 0,
  /** `1` draft (only visible to creator) */
  DRAFT = 1,
  /** `2` partial (e.g. while uploading) */
  PARTIAL = 2,
  /** `3` available (visible to everyone with the relevant rights) */
  AVAILABLE = 3,
  ACCEPTED = 4,
  REJECTED = 5,
  /** `6` completed ShareKey for now */
  COMPLETED = 6,
  /** `7` processed (resource has been closed and can't be modified) */
  PROCESSED = 7,
  /** `9` deleted */
  VALIDATED = 8,
  REMOVED = 9,
  DELETED = 10,
  EXPIRED = 11,
}

export enum TENDER_REGISTRATION_STATE {
  NONE = 0,

  /** `1` draft registration */
  DRAFT = 1,

  /** `3` published & active */
  AVAILABLE = 3,

  /** `6` closed */
  CLOSED = 6,

  /** `7` processed (archived, finished) */
  PROCESSED = 7,
}

export enum RIGHTS_LEVEL {
  /** 1 list, can't do sheit;
   *
   * can only "mark as fav",
   * selection (cherrypick) disabled,
   * upload disabled,
   * create folder disabled,
   */
  LIST = 1,

  /** 2 read (open);
   *
   * download enabled (with selection),
   * copy enabled (need to check destination for WRITE=4)
   */
  OPEN = 2,

  /** 3 create (upload);
   *
   * upload enabled (NO folders)
   */
  UPLOAD = 3,

  /** 4 write (write);
   *
   * folder create/upload enabled
   * file actions (edit, move) enabled (need to check destination for WRITE=4)
   */
  WRITE = 4,

  /** 5 manage (manage);
   *
   * manage folders enabled
   * accessing folder rights enabled
   */
  MANAGE = 5,

  /** super user - should be implemented as edge case (99 value not in api)
   *
   * can access global settings etc.
   * share enabled
   * global permissions enabled
   * su mode enabled
   */
  SUPER_USER = 99,
}

export enum SEC_GROUP_PRIORITY {
  /** 1: WG SG */
  WORKING_GROUPS = 1,
  /** 2: Internal Perm grouping SG */
  INTERNAL = 2,
  /** 3: Reserved */
  RESERVED = 3,
  /** 4: Reserved */
  RESERVED_2 = 4,
  /** 5+ -> custom (Wiredelta custom SG creation and prioritization ) */
  CUSTOM = 5,
}

export enum MODULES {
  /** 1: Task */
  TASK = 1,
  /** 3: Enquiry registration */
  TQ = 3,
  /** 4: Audit registration */
  SUPV = 4,
  /** 5: Inspection registration */
  CONT = 5,
  /** 6: Commissioning registration */
  COM = 6,
  /** 7: Service registration */
  DV = 7,
  /** 8: Contract registration */
  AFTS = 8,
  /** 9:  */
  ECO = 9,
}

export enum TEMPLATE_TYPE {
  /** 0: CWEB Template */
  CWEB_TEMPLATE = 0,
  /** 1: Customer Own Template */
  CUSTOMER_OWN_TEMPLATE = 1,
  /** 2: Has Permitted Project (not used in filter) */
  HAS_PERMITTED_PROJECT = 2,
  /** 3: Other Project */
  OTHER_PROJECT = 3,
}
